
<template>
    <div class="container-fluid mt-3">
        <div class="card ">
            <div class="card-body center grid ">
                <vs-row> 
                    <vs-col w="12">
                        <vs-button
                            success
                            flat
                            class="ml-auto mb-4"
                            @click="activeClonar =! activeClonar"
                        >
                            Clonar código de sesión
                        </vs-button>
                        <clonar v-model="activeClonar" :listInstituciones="listInstituciones"></clonar>
                    </vs-col>
                    <vs-col sm="12" lg="3" >
                        <label for="programa" class="pl-3 mr-1">Institución</label>
                        <form autocomplete="off">
                            <vs-select :loading="loadingSelect" block filter placeholder="Institución" v-model="institucion" v-if="listInstituciones.length"  class="pt-0" @input="getBorrarSeleccion()">
                                <vs-option v-for="option in listInstituciones" :key="option.id"  :label="option.text" :value="option.id" >
                                    {{option.text}}
                                </vs-option>
                                <template #message-danger v-if="errorFields.includes('institucion')">
                                    Requerido
                                </template>
                            </vs-select>
                        </form>
                    </vs-col> 
                    <vs-col sm="12" lg="3" >
                        <label for="programa" class="pl-3 mr-1">Ciclo escolar</label>
                        <form autocomplete="off">
                            <vs-select :loading="loadingCiclo" block filter placeholder="Ciclo escolar" v-model="cicloEscolar" :disabled="!listCiclos.length" class="pt-0" :key="listCiclosId" @input="getBorrarSeleccion(); programa = ''; grado = ''" >
                                <vs-option v-for="option in listCiclos" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                                <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                                    Requerido
                                </template>
                            </vs-select>
                        </form>
                    </vs-col> 
                    <vs-col sm="12" lg="3">
                        <label for="programa" class="pl-3 mr-1">Programa</label>
                        <form autocomplete="off">
                            <vs-select :loading="loadingPrograma" id="programa" filter placeholder="Programa" v-model="programa"  :disabled="!listPrograma.length" class="pt-0" :key="programasId" @input="getBorrarSeleccion(); grado = ''" >
                                <template v-if="listPrograma.length">
                                    <vs-option v-for="option in listPrograma" :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                                </template>
                                <template v-else>
                                    <vs-option label="No hay datos" :value="0">
                                        No hay datos
                                    </vs-option>
                                </template>
                                <template #message-danger v-if="errorFields.includes('programa')">
                                    Requerido
                                </template>
                            </vs-select>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <label for="gr" class="pl-3 mr-1">Grado</label>
                        <form autocomplete="off">
                            <vs-select :loading="loadingGrado" id="grado" filter placeholder="Grado" v-model="grado"  :disabled="!listGrado.length" class="pt-0" :key="gradosId" @input="getBorrarSeleccion()">
                                <template v-if="listGrado.length">
                                    <vs-option v-for="option in listGrado" :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                                </template>
                                <template v-else>
                                    <vs-option label="No hay datos" :value="0">
                                        No hay datos
                                    </vs-option>
                                </template>
                                <template #message-danger v-if="errorFields.includes('grado')">
                                    Requerido
                                </template>
                            </vs-select>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="12" style="display: flex">
                        <vs-button
                            class="ml-auto mb-2"
                            @click="tablaCodigos()"
                        >
                            <i class="fas fa-search mr-2"></i>Buscar
                        </vs-button>
                    </vs-col>
                </vs-row>
                <vs-row>
                    <vs-col class="pl-2 pr-2" vs-justify="center" vs-align="left" sm="12" lg="5" >
                        <codigos :page="page" :pages="pages" :tablaData="tablaData" :institucion="institucion" v-model="selected" :cicloEscolar="cicloEscolar" :programa="programa" :grado="grado"  @refreshTable="tablaCodigos" @tipoboton="getTipoboton" :escalas_especifica="escalas_especifica" :ejecutar="ejecutar" :nivel="nivel"></codigos>
                    </vs-col>
                    <vs-col class="pl-2 pr-2" vs-justify="center" vs-align="center" sm="12" lg="7">
                        <sesiones :institucion="institucion" :crn-id="selectedId" :nombreCodigo="selectedCodigo" :ejecutar="ejecutar" :selectedCodigo="selected" :tipoboton="tipoboton" :personaRol="personaRol"></sesiones>
                    </vs-col>
                </vs-row>
            </div>
        </div>
    </div>
</template>

<script>
import Codigos from './tables/codigos'
import Sesiones  from './tables/sesiones'
import catalogos from '../../../api/requests/catalogos.js'
import cobranza from '../../../api/requests/cobranza-persona'
import crns from '../../../api/requests/crns'
import clonar from './action-modals/clonar.vue'
export default {
    props: [
        'personaRol'
    ],
    data () {
        return {
            listInstituciones:[],
            institucion: '',
            cicloEscolar:'',
            listCiclos: [],
            listCiclosId: (new Date()).getTime(),
            selected: null,
            programa: '',
            listPrograma: [],
            nivel: '',
            niveles: [],
            nivelId:(new Date()).getTime(),
            programasId:(new Date()).getTime(),
            grado: '',
            listGrado: [],
            gradosId:(new Date()).getTime(),
            tablaData:[],
            page: 1,
            pages: 0,
            ejecutar: 0,
            errorGrupo: false,
            errorInstituto: false,
            errorCiclo: false,
            grado: '',
            tache: false,
            loadingSelect:false,
            loadingCiclo:false,
            loadingPrograma:false,
            loadingGrado:false,
            escalas_especifica: [],
            nombreCodigo: '',
            activeClonar: false,
            tipoboton: '',
            errorFields: []
        }
    },
    async created () {
        try {
            const { data: instituciones } = await catalogos.getInstituciones()
            if (Array.isArray(instituciones)){
                this.listInstituciones = instituciones
            }
        } catch (error) {
        }
    },
    methods: {
        async listadosPorInstitucion () {
            if (this.institucion) {
                try {
                    this.loadingCiclo = true
                    const { data: ciclosEsc } = await catalogos.getCiclosEscolares(this.institucion)
                    this.listCiclos = ciclosEsc
                    this.listCiclosId = (new Date()).getTime()
                    this.loadingCiclo = false
                } catch (error) {
                }
            }   
        },
        async getNivelesAcademicos () {
            if (this.programa){
                let params = {
                programa: this.programa,
                institucion: this.institucion,
                }
                const { data: response } = await cobranza.getNivel(params) || {}
                const { opciones: niveles, default: val } = response || {}
                if (niveles){
                    this.niveles =  Object.values(niveles)
                    this.nivel = val
                    this.nivelId = (new Date()).getTime()
                    
                }
            }
        },
        async getPrograma(){
            if (this.cicloEscolar) {
                try {
                    this.loadingPrograma = true
                    const {data: response} = await catalogos.getProgramas(this.institucion)
                    this.listPrograma = response
                    this.programasId = (new Date()).getTime()
                    this.loadingPrograma = false
                } catch (error) {
                    
                }
            }
        },
        async getGrado(){
            if (this.cicloEscolar) {
                try {
                    this.loadingGrado = true
                    const {data: response} = await catalogos.getGrado(this.programa)
                    this.listGrado = response
                    this.gradosId = (new Date()).getTime()
                    this.loadingGrado = false
                } catch (error) {
                    
                }
            }
        },
        async getEscalaCalificaciones () {
            try {
                const { data: response } = await catalogos.getEscalaCalificaciones()
                this.escalas_especifica = response
            } catch (error) {
                    
            }
        },
        deseleccionar() {
            this.grado = ''
        },
        
        tablaCodigos () {
            this.errorFields = []
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if (!this.cicloEscolar) {
                this.errorFields.push('cicloEscolar')
            }
            if (!this.programa) {
                this.errorFields.push('programa')
            }
            if (!this.grado) {
                this.errorFields.push('grado')
            }
            if (!this.errorFields.length){
                this.ejecutar += 1
                return true
            } else {
                return null
            }
        },
        getBorrarSeleccion(){
            this.tablaData = []
        },
        getTipoboton(tipoboton){
            // this.tipoboton = tipoboton
        }
    },
    components:{
        Codigos,
        Sesiones,
        clonar
    },
    computed:{
        selectedId () {
            const { id = null} = this.selected || {}
            return id
        },
        selectedCodigo () {
            const { alias = null} = this.selected || {}
            return alias
        }
    },
    watch: {
        institucion(){
            this.listadosPorInstitucion()
            this.getPrograma()
        },
        cicloEscolar(){
            this.getPrograma()
        },
        programa(){
            this.getGrado()
            this.getEscalaCalificaciones()
            this.getNivelesAcademicos()
        }
    }
}

</script>


<style >
.mini-icon {
     font-size: 0.7rem !important;
}
.unset-min-width table {
    min-width: unset !important;
}
.left-header-unset-radius header {
    border-radius: 14px 0px 0px 0px !important;
}
.rigth-footer-unset-radius footer {
    border-radius: 0px 0px 14px 0px;
}
.rigth-header-unset-radius header {
    border-radius: 0px 14px 0px 0px !important;
}
.left-footer-unset-radius footer {
    border-radius: 0px 0px 0px 14px;
}
.vs-input-parent {
    padding: 10px 0px 10px 0px;
}
.vs-select-content {
    padding: 10px 0px 10px 0px;
}
.vs-select--disabled i {
    pointer-events: none !important;
}
</style>

<style lang="scss" scoped>
    .tache{
        position: absolute;
        cursor: pointer;
        top: 30px;
        @media only screen and (max-width: 768px) {
            left: calc(95% - 4em);
        }
        @media only screen and (min-width: 768px) {
            left: calc(98% - 4em);
        }

    }
</style>
